import * as THREE from 'three'
import { createParalellepiped } from './utils'
const gridTexture = require('../textures/grid.png').default

export default function createGround() {
  const pos = new THREE.Vector3()
  const quat = new THREE.Quaternion()

  // Ground
  pos.set(0, -0.5, 0)
  quat.set(0, 0, 0, 1)
  const ground = createParalellepiped(
    40,
    1,
    40,
    0,
    pos,
    quat,
    new THREE.MeshPhongMaterial({ color: 0xffffff }),
  )
  ground.castShadow = true
  ground.receiveShadow = true

  const texture = new THREE.TextureLoader().load(gridTexture)
  texture.wrapS = THREE.RepeatWrapping
  texture.wrapT = THREE.RepeatWrapping
  texture.repeat.set(40, 40)
  ground.material.map = texture
  ground.material.needsUpdate = true

  return { ground, pos, quat }
}
